export default __webpack_public_path__ + "static/media/pic5.c12a6fb2.jpg";